import { axiosInstance, parseResult } from "./CommonApi";

//시스템 공지사항 목록 조회
export const getNoticePostList = async (searchType, query, page, pageSize) => {
    const params = new URLSearchParams();
    if (searchType) {
        params.append("search_type", searchType);
    }
    if (query) {
        params.append("query", query);
    }
    if (page) {
        params.append("page", page);
    }
    if (pageSize) {
        params.append("page_size", pageSize);
    }

    const response = await axiosInstance.get(`/community/notice-post/list/`, { params });
    return parseResult(response);
};

export const getNoticePostListByUrl = async (url) => {
    const response = await axiosInstance.get(url);
    return parseResult(response);
};

//공지사항 단건 조회
export const getNoticePost = async (id) => {
    const params = { id: id };
    const response = await axiosInstance.get(`/community/notice-post/${id}/`, { params });
    return parseResult(response);
};

//사용자 게시글 새글쓰기
export const createBoard = async (requestBody) => {
    const response = await axiosInstance.post(
        `/community/board/create/`,
        requestBody,
        {
            headers: { "Content-Type": "multipart/form-data" },
        }
    );
    return parseResult(response);
};

//사용자 게시글 목록 조회
export const getBoardList = async (searchType, query, page, pageSize) => {
    const params = new URLSearchParams();
    if (searchType) {
        params.append("search_type", searchType);
    }
    if (query) {
        params.append("query", query);
    }
    if (page) {
        params.append("page", page);
    }
    if (pageSize) {
        params.append("page_size", pageSize);
    }

    const response = await axiosInstance.get(`/community/board/list/`, { params });
    return parseResult(response);
};

export const getBoardListByUrl = async (url) => {
    const response = await axiosInstance.get(url);
    return parseResult(response);
};

//사용자 게시글 단건 조회
export const getBoard = async (id) => {
    const params = { id: id };
    const response = await axiosInstance.get(`/community/board/${id}/`, { params });
    return parseResult(response);
};

//답변 등록/수정
export const replyBoard = async (id, requestBody) => {
    const params = { id: id };
    const response = await axiosInstance.post(
        `/community/board/reply/${id}/`,
        requestBody,
        {
            params: params,
            headers: { "Content-Type": "application/json" },
        }
    );
    return parseResult(response);
};

//비공개 게시글 비밀번호 확인
export const checkPasswordBoard = async (id, requestBody) => {
    const params = { id: id };
    const response = await axiosInstance.post(
        `/community/board/check-password/${id}/`,
        requestBody,
        {
            params: params,
            headers: { "Content-Type": "application/json" },
        }
    );
    return parseResult(response);
};